import { Box, Button, Container, Typography, Menu, MenuItem, IconButton, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import React from "react";
import { Link } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import  EditTwoTone from "@mui/icons-material/EditTwoTone";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { getRecipients } from "../reducers/userReducer";

const RecipientsCard = ({
  id,
  name,
  nickName,
  phone,
  bank_account_number,
  bank_name,
  ifsc,
  email,
  pan,
  onClickEdit,
  dispatch,
  onClickDelete,
  is_bank_added,
  relationship,
  currentPage,
}) => {

  const textRef = useRef(null);
  const [underlineWidth, setUnderlineWidth] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const open = Boolean(anchorEl);
 const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDeleteClick = () => {
    handleClose();
    setDeleteDialogOpen(true);
  };

  const handleDeleteConfirm = () => {
    setDeleteDialogOpen(false);
    dispatch(getRecipients({page : currentPage}));
    onClickDelete(id);
  };

  const handleDeleteCancel = () => {
    setDeleteDialogOpen(false);
  };

  useEffect(() => {
    if (textRef.current) {
      const textWidth = textRef.current.offsetWidth;
      setUnderlineWidth(textWidth);
    }
  }, []);


  return (
    <Box
      sx={{
        p: { xs: 2, md: 1 },
        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
        borderRadius: 2,
        border: 1,
        borderColor: "brand.main",
        my: 3,
        py: { md: 3 },
        bgcolor: "background.paper",
        cursor: "default",
        transition: "box-shadow 0.3s ease-in-out",
        "&:hover": {
          boxShadow: 6,
        },
        "@media (max-width: 375px)": {
          p: 2,
          my: 2,
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          paddingLeft: 0,
          alignItems: "space-between",
          position: "relative",
          mb: 2,
        }}
      >
        <Container sx={{ display: "flex", alignItems: "center" }}>
          <Typography
            ref={textRef}
            variant="h5"
            fontWeight={400}
            sx={{
              position: "relative",
              fontSize: { xs: "1rem", sm: "1.5rem" },
              "&:after": {
                content: '""',
                position: "absolute",
                bottom: -8,
                left: 0,
                width: `${underlineWidth}px`, // Dynamic width
                height: 3,
                backgroundColor: "brand.main",
                transition: "width 0.3s ease", // Optional animation
              },
            }}
          >
            {nickName.charAt(0).toUpperCase() + nickName.slice(1)}
          </Typography>
        </Container>
        <div>
          <IconButton
            aria-label="more"
            id="long-button"
            aria-controls={open ? 'long-menu' : undefined}
            aria-expanded={open ? 'true' : undefined}
            aria-haspopup="true"
            onClick={handleClick}
            sx={{
              color: 'brand.main',
              '&:hover': {
                color: '#004d40',
              },
            }}
          >
            <MoreVertIcon />
          </IconButton>
          <Menu
            id="long-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            PaperProps={{
              elevation: 3,
              sx: {
                minWidth: 120,
              },
            }}
          >
            <MenuItem onClick={() => {
              handleClose();
              onClickEdit({
                name,
                nickName,
                email,
                ifsc,
                bank_account_number,
                phone,
                id,
                relationship,
              });
            }}>
              <EditTwoTone sx={{ mr: 1, fontSize: 20 }} />
              Edit
            </MenuItem>
            <MenuItem onClick={handleDeleteClick} sx={{ color: 'error.main' }}>
              <DeleteOutlineIcon sx={{ mr: 1, fontSize: 20 }} />
              Delete
            </MenuItem>
          </Menu>

          <Dialog
            open={deleteDialogOpen}
            onClose={handleDeleteCancel}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              {"Confirm Delete"}
            </DialogTitle>
            <DialogContent>
              <Typography>
                Are you sure you want to delete {nickName}? This action cannot be undone.
              </Typography>
            </DialogContent>
            <DialogActions>
              <Button 
                onClick={handleDeleteCancel}
                sx={{ 
                  color: 'text.secondary',
                  '&:hover': {
                    backgroundColor: 'action.hover'
                  }
                }}
              >
                Cancel
              </Button>
              <Button 
                onClick={handleDeleteConfirm}
                color="error"
                variant="contained"
                autoFocus
              >
                Delete
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </Box>

      <Box>
        {/* {phone.length = 10 && <Container
          sx={{
            display: "flex",
            justifyContent: "space-between",
            paddingLeft: 0,
            alignItems: "center",
          }}
        >
          <Typography variant="body1" lineHeight={1.2}>
            Phone:
          </Typography>
          <Typography color="text.secondary" variant="body1" lineHeight={1.2}>
            {formatPhone(phone)}
          </Typography>
        </Container>} */}

        {email && (
          <Container
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mb: 1,
            }}
          >
            <Typography variant="body1" lineHeight={1.2}>
              Email:
            </Typography>
            <Typography color="text.secondary" variant="body1" lineHeight={1.2}>
              {email}
            </Typography>
          </Container>
        )}

        {name && (
          <Container
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mb: 1,
            }}
          >
            <Typography variant="body1" lineHeight={1.2}>
              Account holder name:
            </Typography>
            <Typography color="text.secondary" variant="body1" lineHeight={1.2}>
              {name}
            </Typography>
          </Container>
        )}

        {bank_account_number && (
          <Container
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 1,
            }}
          >
            <Typography variant="body1" lineHeight={1.2}>
              Bank account number:
            </Typography>
            <Typography color="text.secondary" variant="body1" lineHeight={1}>
              {bank_account_number}
            </Typography>
          </Container>
        )}

        {ifsc && (
          <Container
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mb: 1,
            }}
          >
            <Typography variant="body1" lineHeight={1}>
              IFSC code:
            </Typography>
            <Typography color="text.secondary" variant="body1" lineHeight={1}>
              {ifsc}
            </Typography>
          </Container>
        )}

        <Container
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="body1" lineHeight={1.2}>
            Relationship:
          </Typography>
          <Typography color="text.secondary" variant="body1" lineHeight={1}>
            {relationship}
          </Typography>
        </Container>

        <Container
          sx={{
            display: "flex",
            justifyContent: "center",
            paddingLeft: 0,
            alignItems: "center",
            position: "relative",
          }}
        >
          <Link
            to={`/transaction/create/${phone}`}
            style={{
              ...(is_bank_added !== 1 && { pointerEvents: "none" }),
            }}
          >
            <Button
              color="primary"
              variant="contained"
              sx={{
                mt: 2,
                borderRadius: 2,
                bgcolor: "brand.main",
                "&:hover": {
                  bgcolor: "brand.dark",
                },
                "@media (max-width: 375px)": {
                  width: "100%",
                },
              }}
              disabled={is_bank_added !== 1}
            >
              <Typography textAlign={"center"} color={"#FFF"}>
                Start transfer
              </Typography>
            </Button>
          </Link>
        </Container>
      </Box>
      <ToastContainer hideProgressBar position="top-center" />
    </Box>
  );
};

export default RecipientsCard;
